module.exports = __webpack_public_path__ + "static/media/felicity-jones-win.426c11b7.jpg";